/* KLOV — Once Upon A Time */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loaded() { requestAnimationFrame(function () { root.classList.add('is-loaded'); }); }
  if (document.readyState === 'complete') loaded(); else window.addEventListener('load', loaded);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(loaded, 600); });

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (!header.classList.contains('menu-open')) {
        header.classList.toggle('is-hidden', y > 400 && y > lastY + 4);
        if (y < lastY - 4) header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    var toggle = header.querySelector('[data-menu-toggle]');
    var menu = header.querySelector('[data-mobile-menu]');
    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        header.classList.toggle('menu-open', open);
        document.body.classList.toggle('dialog-open', open);
        if (open) {
          menu.hidden = false;
          requestAnimationFrame(function () { menu.classList.add('is-open'); });
        } else {
          menu.classList.remove('is-open');
          setTimeout(function () { menu.hidden = true; }, 500);
        }
      });
    }
  }

  function initParallax() {
    if (reduced) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        el.style.transform = 'translate3d(0,' + (-r.top * 0.18).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function refreshCartCount() {
    fetch((window.KLOV && window.KLOV.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  /* Made-to-order customiser: every choice becomes a line item property */
  function initCustomizer() {
    var dialog = document.querySelector('[data-customizer]');
    if (!dialog) return;
    var form = dialog.querySelector('[data-customizer-form]');
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
    var progress = form.querySelectorAll('[data-progress]');
    var btnNext = form.querySelector('[data-next]');
    var btnPrev = form.querySelector('[data-prev]');
    var btnSubmit = form.querySelector('[data-submit]');
    var stepNum = form.querySelector('[data-step-num]');
    var variantInput = form.querySelector('[data-variant-input]');
    var colourProp = form.querySelector('[data-colour-property]');
    var priceEls = form.querySelectorAll('[data-custom-price], [data-submit-price]');
    var summary = form.querySelector('[data-summary]');
    var done = form.querySelector('[data-done]');
    var current = 1;
    var lastFocus = null;

    document.querySelectorAll('[data-open-customizer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lastFocus = btn;
        reset(); /* always start a new commission from Step I with a fresh form */
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
        document.body.classList.add('dialog-open');
        var first = steps[current - 1].querySelector('input:not([disabled]), textarea:not([disabled])');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
      });
    });
    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () {
      document.body.classList.remove('dialog-open');
      if (dialog.classList.contains('is-complete')) reset();
      if (lastFocus) lastFocus.focus();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-customizer]')) close();
    });

    var conditionals = Array.prototype.slice.call(form.querySelectorAll('[data-show-when]'));
    function checkedValue(name) {
      var els = form.elements[name];
      if (!els) return null;
      if (els.length === undefined || els.tagName) return els.checked ? els.value : null;
      for (var i = 0; i < els.length; i++) if (els[i].checked) return els[i].value;
      return null;
    }
    function applyConditionals() {
      conditionals.forEach(function (box) {
        var rule = box.getAttribute('data-show-when');
        var idx = rule.indexOf('=');
        var name = rule.slice(0, idx), value = rule.slice(idx + 1);
        var show = checkedValue(name) === value;
        box.hidden = !show;
        box.querySelectorAll('input, textarea, select').forEach(function (el) { el.disabled = !show; });
      });
    }

    function syncColour() {
      var chosen = form.querySelector('input[name="colour_choice"]:checked');
      if (!chosen) { colourProp.value = ''; return; }
      variantInput.value = chosen.getAttribute('data-variant-id');
      var price = chosen.getAttribute('data-price');
      priceEls.forEach(function (el) { el.textContent = price; });
      colourProp.value = chosen.value === '__custom' ? 'Custom Colour Request' : chosen.value;
    }

    form.addEventListener('change', function (e) {
      applyConditionals();
      if (e.target.name === 'colour_choice') syncColour();
      var f = e.target.closest('.field, .choice-grid, .size-row, .chip-row');
      if (f) f.classList.remove('is-invalid');
      var err = steps[current - 1].querySelector('[data-error]');
      if (err) err.hidden = true;
    });
    form.addEventListener('input', function (e) {
      var f = e.target.closest('.field');
      if (f) f.classList.remove('is-invalid');
      if (e.target.name === 'properties[Initials]') e.target.value = e.target.value.toUpperCase();
    });

    var messages = {
      1: 'Please choose a colour — or describe your custom colour.',
      2: 'Please choose a size, or complete every measurement.',
      3: 'Please choose your embroidery and beadwork, and describe any customisation.',
      4: 'Please confirm you understand this piece is made to order.'
    };
    function validateStep(n) {
      var step = steps[n - 1];
      var ok = true;
      var radiosSeen = {};
      step.querySelectorAll('input, textarea').forEach(function (el) {
        if (el.disabled || !el.required) return;
        if (el.type === 'radio') {
          if (radiosSeen[el.name]) return;
          radiosSeen[el.name] = true;
          if (!checkedValue(el.name)) {
            ok = false;
            var g = el.closest('.choice-grid, .size-row, .chip-row');
            if (g) g.classList.add('is-invalid');
          }
        } else if (el.type === 'checkbox') {
          if (!el.checked) ok = false;
        } else {
          var val = el.value.trim();
          var bad = !val || (el.type === 'number' && (isNaN(parseFloat(val)) || parseFloat(val) <= 0));
          if (bad) { ok = false; var fld = el.closest('.field'); if (fld) fld.classList.add('is-invalid'); }
        }
      });
      var err = step.querySelector('[data-error]');
      if (err) { err.hidden = ok; err.textContent = ok ? '' : messages[n]; }
      if (!ok) {
        var firstBad = step.querySelector('.is-invalid');
        if (firstBad && firstBad.scrollIntoView) firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }

    var measureKeys = ['Height', 'Bust', 'Waist', 'Hips', 'Shoulder', 'Sleeve Length', 'Garment Length', 'Trouser Length'];
    function buildSummary() {
      var data = new FormData(form);
      var unit = checkedValue('properties[Measurement Unit]');
      summary.innerHTML = '';
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        var v = String(value).trim();
        if (!m || !v || m[1] === 'Made to Order Acknowledged') return;
        var d = document.createElement('div');
        var dt = document.createElement('dt'); dt.textContent = m[1];
        var dd = document.createElement('dd');
        dd.textContent = (unit && measureKeys.indexOf(m[1]) > -1) ? v + ' ' + (unit === 'cm' ? 'cm' : 'in') : v;
        d.appendChild(dt); d.appendChild(dd); summary.appendChild(d);
      });
    }

    function goTo(n, back) {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === n - 1);
        s.classList.toggle('is-back', !!back && i === n - 1);
      });
      progress.forEach(function (p) {
        var k = +p.getAttribute('data-progress');
        p.classList.toggle('is-current', k === n);
        p.classList.toggle('is-done', k < n);
      });
      current = n;
      stepNum.textContent = n;
      btnPrev.hidden = n === 1;
      btnNext.hidden = n === steps.length;
      btnSubmit.hidden = n !== steps.length;
      if (n === steps.length) buildSummary();
      var scroller = form.querySelector('.custom__layout');
      if (scroller && scroller.scrollTo) scroller.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    }
    btnNext.addEventListener('click', function () { if (validateStep(current)) goTo(current + 1); });
    btnPrev.addEventListener('click', function () { goTo(current - 1, true); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      for (var i = 1; i <= steps.length; i++) {
        if (!validateStep(i)) { goTo(i); validateStep(i); return; }
      }
      syncColour();
      var data = new FormData(form);
      var body = { id: Number(data.get('id')), quantity: 1, properties: {} };
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(value).trim()) body.properties[m[1]] = String(value).trim();
      });
      var unit = body.properties['Measurement Unit'];
      if (body.properties['Sizing'] === 'Custom Measurements' && unit) {
        measureKeys.forEach(function (k) {
          if (body.properties[k]) body.properties[k] = body.properties[k] + ' ' + (unit === 'cm' ? 'cm' : 'in');
        });
      }

      btnSubmit.disabled = true;
      var label = btnSubmit.innerHTML;
      btnSubmit.textContent = 'Adding…';
      var addUrl = (window.KLOV && window.KLOV.routes.cartAdd) || '/cart/add';
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to bag.');
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          done.hidden = false;
          dialog.classList.add('is-complete');
          refreshCartCount();
        })
        .catch(function (err) {
          var el = steps[steps.length - 1].querySelector('[data-error]');
          el.hidden = false;
          el.textContent = err.message;
        })
        .finally(function () {
          btnSubmit.disabled = false;
          btnSubmit.innerHTML = label;
        });
    });

    function reset() {
      form.reset();
      dialog.classList.remove('is-complete');
      done.hidden = true;
      form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
      applyConditionals();
      syncColour();
      goTo(1);
    }

    applyConditionals();
    syncColour();
    goTo(1);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
    initParallax();
    initCustomizer();
  });
})();
